import axios from '../axios'

/**
 * 分账回退
 * @param {*} data
 * orderId
 * @wiki http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12059799 20220524
 */
export const subAccountRollback = data => {
  const { orderId } = data;
  return axios({
    url: `/order/profitSharingReturn/${orderId}`,
    method: 'post',
    data
  })
}
/**
 * 分账
 * @param {*} data
 * @returns
 */
export const subAccount = data => {
  const { orderId } = data;
  return axios({
    url: `/order/profitSharing/${orderId}`,
    method: 'post',
    data
  })
}
/**
 * 查询退款记录列表
 * @param {*} data
 * orderId 是 String 订单id
 * state	否	java.lang.String	1:退款失败 2:退款成功
 * userName 否	java.lang.String 学员姓名
 * @wiki  http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12059807  20220524
 */
export const listRefund = data => {
  return axios({
    url: '/refund/list',
    method: 'post',
    data
  })
}
/**
 * 查询分账记录
 * @param {*} data
 * orderId 是 String 订单id
 * @wiki  http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12059809  20220524
 */
export const listSubAccount = data => {
  return axios({
    url: '/orderSplitAccount/list',
    method: 'post',
    data
  })
}
/**
 * 导出Excel
 * @param deptName 驾校名称
 * @param studentName 学员名称
 * @param state 订单状态
 * @param  idCard 身份证号
 * @wiki http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=702525
 */
export const exportExcel = data => {
  return axios({
    url: '/order/exportExcel',
    method: 'post',
    responseType: 'blob',
    data
  })
}
/**
 * 查询
 */
export const findPage = data => {
  return axios({
    url: '/order/list',
    method: 'post',
    data
  })
}

/**
 * 绑定
 */
export const bind = data => {
  return axios({
    url: '/order/bind',
    method: 'post',
    data
  })
}

/**
 * 退款
 *
  id	是	string	订单ID
  reason	是	string	退款原因
  refundFee	是	string	退款金额
  type	是	string	1:部分退款 0 ： 全额退款

 * @wiki  http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=688602  20220418
 */
export const refund = data => {
  return axios({
    url: '/order/applyRefund',
    method: 'post',
    data
  })
}
/**
 * 考试订单列表查询
 * @param deptId 培训机构id
 * @param studentName
 * @param state 订单状态
 * @param idCard
 * @param examOrderNo  订单编号
 * @param orderBeginDate
 * @param orderEndDate
 * @param transactionId  支付订单号
 * @wiki http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=703021
 */
export const getExamOrderList = data => {
  return axios({
    url: '/examOrder/list',
    method: 'post',
    data,
  })
}
/**
 * 考试订单列表导出
 * @param 参数同 getExamOrderList()
 * @wiki http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=703029
 */
export const exportExcelExamOrder = data => {
  return axios({
    url: '/examOrder/exportExcel',
    method: 'post',
    responseType: 'blob',
    data,
  })
}
/**
 * 考试订单列表查询
 * type 	1:部分退款 0 ： 全额退款
 * refundFee 退款金额
 * reason 退款原因
 * id 订单ID
 * @wiki http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=703021
 */
export const applyRefund = data => {
  return axios({
    url: '/examOrder/applyRefund',
    method: 'post',
    data,
  })
}
/**
 * 查询考试退款记录列表
 * @param {*} data
 * orderId 是 String 订单id
 * state	否	java.lang.String	1:退款失败 2:退款成功
 * userName 否	java.lang.String 学员姓名
 * @wiki  http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12059807  20220524
 */
export const listExamRefund = data => {
  return axios({
    url: '/examOrderReFund/list',
    method: 'post',
    data
  })
}
/**
 * 绑定课程
 * @param {*} data
 * orderId 是 String 订单id
 * @wiki  http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12059807  20220728
 */
export const bindScheme = orderId => {
  return axios({
    url: '/order/bindScheme/' + orderId,
  })
}
/**
 * 解除绑定课程
 * @param {*} data
 * orderId 是 String 订单id
 * @wiki  http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=17629368  20220729
 */
export const unBindScheme = orderId => {
  return axios({
    url: '/order/unBindScheme/' + orderId,
  })
}

export const coursePostpone = stuId => {
  return axios({
    url: '/order/postpone/' + stuId,
  })
}





// WEBPACK FOOTER //
// ./src/http/modules/order.js